export default "__VITE_ASSET__DcMT9cJD__"